export default "__VITE_PUBLIC_ASSET__8713e6d7__"